var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-table"},[(_vm.isResult)?_c('Result'):[_c('Controls',{attrs:{"inGame":""}}),_c('Deck',{attrs:{"cards":_vm.cards}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }